import BaseUseCase from "../../base_use_case.js";

class IdentifyCurrentUserUseCase extends BaseUseCase {

  execute(token) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "post",
      url: `/api/v1/users/current_user/identify`,
      data: {
        identificationToken: token
      }
    });
  }
}

const instance = new IdentifyCurrentUserUseCase();
export default instance;